import { Controller } from "@hotwired/stimulus"

// The admin's "new country" fields. Typing a country the platform knows fills
// its ISO code and suggests a domain, and every preview of the copied wording
// follows the name as it is typed — so the rename is something you can read
// before you commit to it, not a promise.
export default class extends Controller {
  static targets = ["name", "code", "domain", "preview", "before"]
  static values = { codes: Object, domainSuffix: String }

  connect() {
    this.sync()
  }

  sync() {
    const name = this.nameTarget.value.trim()
    const code = this.codesValue[name]

    if (code && this.codeIsUntouched) this.codeTarget.value = code
    if (this.hasDomainTarget) this.domainTarget.placeholder = this.domainExample(name)
    this.previewTargets.forEach((preview) => this.renamePreview(preview, name))
    // The line as it reads today is only worth showing next to a line that changed.
    this.beforeTargets.forEach((before, index) => { before.hidden = this.previewTargets[index]?.dataset.changed !== "true" })
  }

  // Once an admin types a code themselves, the list stops overwriting it.
  codeTyped() {
    this.codeTouched = true
  }

  get codeIsUntouched() {
    return !this.codeTouched
  }

  domainExample(name) {
    const label = (name || "new-portal").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")
    return `${label}.${this.domainSuffixValue}`
  }

  // data-country-field-sample holds a real string from the copied data with
  // the source country's name in it; the preview shows what it becomes.
  renamePreview(preview, name) {
    const sample = preview.dataset.countryFieldSample || ""
    const from = preview.dataset.countryFieldFrom || ""
    if (!from) return

    preview.textContent = name ? sample.replaceAll(from, name) : sample
    preview.dataset.changed = String(Boolean(name) && sample.includes(from))
  }
}
